import { useUserSearchGet } from "@dealer-center/ddc-pages-user-search-fetch";

import { useEffect, useState } from "react";
import { PagesUserSearchUiDisplay } from "./Display";

export const PagesUserSearchUi = () => {
  const [nameInput, setNameInput] = useState<string | undefined | number>("");
  const [name, setName] = useState("");
  const { data, error, isLoading: loading } = useUserSearchGet(name);
  useEffect(() => {
    document.title = "UserSearch";
  }, []);
  return (
    <PagesUserSearchUiDisplay
      data={data}
      error={error}
      loading={loading}
      nameInput={nameInput?.toString() || ""}
      setName={setName}
      setNameInput={setNameInput}
    />
  );
};
